import styled from 'styled-components';
import WorkingIcon from '@/assets/mo/working.svg?react';
import ExpertStatsCard from './ExpertStatsCard';
import UploadGuideCard from './UploadGuideCard';
import NoticeBanner from './NoticeBanner';
import ReviewPrompt from './ReviewPrompt';
import { useState } from 'react';
import FilterModal from '../Review/FilterModal';

const MobileMain = () => {
  // ✅ 필터 상태 및 모달 열기 상태
  const [openModal, setOpenModal] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<{
    보험종류: string[];
    사고유형: string[];
  }>({
    보험종류: [],
    사고유형: [],
  });

  return (
    <>
      <Wrapper>
        <ApplyCard>
          <ContentRow>
            <ContentDetail>
              <WorkingIcon />
              <TitleText>
                손해사정사가 필요하다면 <br />
                지금 바로 선임하세요
              </TitleText>
            </ContentDetail>
            <DescriptionText>
              신청만 하시면 무료/유료 구분 없이 어떻게 해야할지 알려드릴게요
            </DescriptionText>
          </ContentRow>
          <ButtonWrapper>
            <ApplyButton onClick={() => (window.location.href = '/appointment')}>
              신청하기
            </ApplyButton>
          </ButtonWrapper>
        </ApplyCard>
        <ExpertStatsCard />
        <UploadGuideCard />
        <NoticeBanner />
        <ReviewPrompt onOpenModal={() => setOpenModal(true)} selectedFilters={selectedFilters} />
      </Wrapper>
      <FilterModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={(filters) => {
          setSelectedFilters({
            보험종류: Array.isArray(filters.보험종류) ? filters.보험종류 : [filters.보험종류],
            사고유형: Array.isArray(filters.사고유형) ? filters.사고유형 : [filters.사고유형],
          });
          setOpenModal(false);
        }}
      />
    </>
  );
};

export default MobileMain;

// Styled Components

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  padding: 80px 16px 20px 16px;
`;
const ApplyCard = styled.section`
  display: flex;
  width: 100%;
  padding: 30px 19px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 32px;
  background: var(--Primary-white, #fff);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1.5px);
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  text-align: start;
`;

const ContentDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const TitleText = styled.div`
  color: var(--gray-ui_gray01, #191919);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 27px */
  letter-spacing: -0.36px;
`;

const DescriptionText = styled.p`
  align-self: stretch;
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  text-align: start;
`;

const ButtonWrapper = styled.div`
  display: flex;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const ApplyButton = styled.button`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 99px;
  background: var(--Primary-brand_01, #0b46dd);

  color: var(--Primary-white, #fff);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.28px;
  border: none;
  cursor: pointer;
`;
